<template>
  <div class="flex">
    <div class="w-full p-20">
      <h4 class="pl-4 font-semibold text-xl">Laboratory</h4>
      <table class="table-auto min-w-full bg-white shadow-md rounded-lg">
        <thead class="bg-gray-200 text-black">
          <tr>
            <th class="py-3 px-6 text-left text-sm font-semibold">Lab Test</th>
            <th class="py-3 px-6 text-left text-sm font-semibold">Priority</th>
            <th class="py-3 px-6 text-left text-sm font-semibold">Location</th>
            <th class="py-3 px-6 text-left text-sm font-semibold">Unit</th>
            <th class="py-3 px-6 text-left text-sm font-semibold">Unit Price</th>
            <th class="py-3 px-6 text-left text-sm font-semibold">Total</th>
            <th>
              <button
                class="text-white font-bold bg-yellow-500 w-8 h-8 rounded-full flex items-center justify-center"
                @click.prevent="addLabTest"
              >
                +
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(test, index) in labRequests" :key="index">
            <td class="text-center align-middle px-2">
              <multiselect
                v-model="test.test_type"
                :options="labTests"
                :multiple="false"
                :searchable="true"
                :internal-search="false"
                @search-change="onSearch"
                @select="labChange($event, index)"
                placeholder="Type to search and select"
                label="name"
                track-by="id"
                class="w-full border-gray-300 rounded p-1 bg-gray-50"
              ></multiselect>
            </td>
            <td class="text-center align-middle">
              <select
                v-model="test.priority"
                class="border-gray-300 rounded p-2 mt-1 bg-gray-50 w-full"
              >
                <option value="" disabled selected>Select (Normal, Urgent, STAT)</option>
                <option value="Normal">Normal</option>
                <option value="Urgent">Urgent</option>
                <option value="STAT">STAT</option>
              </select>
            </td>
            <!-- Referred Out toggle -->
            <td class="text-center align-middle px-4">
              <label class="inline-flex items-center gap-2 cursor-pointer select-none">
                <div
                  class="relative w-10 h-5 rounded-full transition-colors duration-200 cursor-pointer"
                  :class="test.referred_out ? 'bg-custom-yellow' : 'bg-gray-300'"
                  @click="test.referred_out = !test.referred_out"
                >
                  <span
                    class="absolute top-0.5 left-0.5 w-4 h-4 bg-white rounded-full shadow transition-transform duration-200"
                    :class="test.referred_out ? 'translate-x-5' : 'translate-x-0'"
                  />
                </div>
                <span class="text-xs font-medium" :class="test.referred_out ? 'text-amber-600' : 'text-gray-600'">
                  {{ test.referred_out ? 'Referred Out' : 'In-house' }}
                </span>
              </label>
            </td>
            <td class="text-center align-middle">1</td>
            <td class="text-center align-middle">Ksh. {{ test.unit_price }}</td>
            <td class="text-center align-middle">Ksh. {{ test.unit_price }}</td>
            <td>
              <button
                class="text-white font-bold bg-red-500 w-8 h-8 rounded-full flex items-center justify-center"
                @click.prevent="removeLabTest(index)"
              >
                -
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <!-- Radiology Section -->
  <div class="flex">
    <div class="w-full p-20">
      <h4 class="pl-4 font-semibold text-xl">Radiology</h4>
      <table class="table-auto min-w-full bg-white shadow-md rounded-lg">
        <thead class="bg-gray-200 text-black">
          <tr>
            <th class="py-3 px-6 text-left text-sm font-semibold">Imaging Type</th>
            <th class="py-3 px-6 text-left text-sm font-semibold">Priority</th>
            <th class="py-3 px-6 text-left text-sm font-semibold">Location</th>
            <th class="py-3 px-6 text-left text-sm font-semibold">Body Part</th>
            <th class="py-3 px-6 text-left text-sm font-semibold">Unit</th>
            <th class="py-3 px-6 text-left text-sm font-semibold">Unit Price</th>
            <th class="py-3 px-6 text-left text-sm font-semibold">Total</th>
            <th>
              <button
                class="text-white font-bold bg-yellow-500 w-8 h-8 rounded-full flex items-center justify-center"
                @click.prevent="addRadiologyTest"
              >
                +
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(test, index) in radiologyRequests" :key="index">
            <td class="text-center align-middle px-2">
              <multiselect
                v-model="test.imaging_type"
                :options="radiologyTests"
                :multiple="false"
                :searchable="true"
                :internal-search="false"
                @search-change="onRadiologySearch"
                @select="radiologyChange($event, index)"
                placeholder="Type to search and select"
                label="name"
                track-by="id"
                class="w-full border-gray-300 rounded p-1 bg-gray-50"
              ></multiselect>
            </td>
            <td class="text-center align-middle">
              <select
                v-model="test.priority"
                class="border-gray-300 rounded p-2 mt-1 bg-gray-50 w-full"
              >
                <option value="" disabled selected>Select (Normal, Urgent, STAT)</option>
                <option value="Normal">Normal</option>
                <option value="Urgent">Urgent</option>
                <option value="STAT">STAT</option>
              </select>
            </td>
            <!-- Referred Out toggle -->
            <td class="text-center align-middle px-4">
              <label class="inline-flex items-center gap-2 cursor-pointer select-none">
                <div
                  class="relative w-10 h-5 rounded-full transition-colors duration-200 cursor-pointer"
                  :class="test.referred_out ? 'bg-custom-yellow' : 'bg-gray-300'"
                  @click="test.referred_out = !test.referred_out"
                >
                  <span
                    class="absolute top-0.5 left-0.5 w-4 h-4 bg-white rounded-full shadow transition-transform duration-200"
                    :class="test.referred_out ? 'translate-x-5' : 'translate-x-0'"
                  />
                </div>
                <span class="text-xs font-medium" :class="test.referred_out ? 'text-amber-600' : 'text-gray-600'">
                  {{ test.referred_out ? 'Referred Out' : 'In-house' }}
                </span>
              </label>
            </td>
            <td class="text-center align-middle px-2">
              <input
                type="text"
                v-model="test.bodyPartRegion"
                placeholder="e.g. Chest"
                class="w-full border-gray-300 rounded p-1 bg-gray-50"
              />
            </td>
            <td class="text-center align-middle">1</td>
            <td class="text-center align-middle">Ksh. {{ test.unit_price }}</td>
            <td class="text-center align-middle">Ksh. {{ test.unit_price }}</td>
            <td>
              <button
                class="text-white font-bold bg-red-500 w-8 h-8 rounded-full flex items-center justify-center"
                @click.prevent="removeRadiologyTest(index)"
              >
                -
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <!-- Procedure Services Section -->
  <div class="flex">
    <div class="w-full p-20">
      <h4 class="pl-4 font-semibold text-xl">Procedure Services</h4>
      <table class="table-auto min-w-full bg-white shadow-md rounded-lg">
        <thead class="bg-gray-200 text-black">
          <tr>
            <th class="py-3 px-6 text-left text-sm font-semibold">Procedure</th>
            <th class="py-3 px-6 text-left text-sm font-semibold">Unit</th>
            <th class="py-3 px-6 text-left text-sm font-semibold">Unit Price</th>
            <th class="py-3 px-6 text-left text-sm font-semibold">Total</th>
            <th class="py-3 px-6 text-left text-sm font-semibold">Quantity</th>
            <th>
              <button
                class="text-white font-bold bg-yellow-500 w-8 h-8 rounded-full flex items-center justify-center"
                @click.prevent="addProcedure"
              >
                +
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(procedure, index) in procedureRequests" :key="index">
            <td class="text-center align-middle px-2">
              <multiselect
                v-model="procedure.procedure_type"
                :options="procedures"
                :multiple="false"
                :searchable="true"
                :internal-search="false"
                @search-change="onProcedureSearch"
                @select="procedureChange($event, index)"
                placeholder="Type to search procedures"
                label="name"
                track-by="id"
                class="w-full border-gray-300 rounded p-1 bg-gray-50"
              ></multiselect>
            </td>
            <td class="text-center align-middle">{{ procedure.quantity }}</td>
            <td class="text-center align-middle">Ksh. {{ procedure.unit_price }}</td>
            <td class="text-center align-middle">Ksh. {{ procedure.unit_price * procedure.quantity }}</td>
            <td class="px-4 py-1 whitespace-nowrap">
              <div class="flex items-center space-x-1">
                <button @click.prevent="decrementQty(index)" class="w-8 h-8 bg-gray-200 rounded text-sm font-bold hover:bg-gray-300">−</button>
                <span class="w-6 text-center text-sm font-semibold">{{ proc?.quantity }}</span>
                <button @click.prevent="incrementQty(index)" class="w-8 h-8 bg-gray-200 rounded text-sm font-bold hover:bg-gray-300">+</button>
              </div>
            </td>
            <td>
              <button
                class="text-white font-bold bg-red-500 w-8 h-8 rounded-full flex items-center justify-center"
                @click.prevent="removeProcedure(index)"
              >
                -
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="flex">
    <div class="w-full p-20">
      <h4 class="pl-4 font-semibold text-xl">Pharmacy</h4>
      <table class="table-auto min-w-full bg-white shadow-md rounded-lg">
        <thead class="bg-gray-200 text-black">
          <tr>
            <th class="py-3 px-6 text-left text-sm font-semibold">Drug</th>
            <th class="py-3 px-6 text-left text-sm font-semibold">Dose</th>
            <th class="py-3 px-6 text-left text-sm font-semibold">Frequency</th>
            <th class="py-3 px-6 text-left text-sm font-semibold">Duration</th>
            <th class="py-3 px-6 text-left text-sm font-semibold">Administration Route</th>
            <th class="py-3 px-6 text-left text-sm font-semibold">Quantity</th>
            <th class="py-3 px-6 text-left text-sm font-semibold">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(prescription, index) in tempPrescriptionForms" :key="`temp-${index}`" class="">
            <td class="text-center align-middle px-2 mt-1 w-3/12">
              <div class="search-wrapper z-99">
                <v-select
                  class="flowbite-select"
                  v-model="prescription.inventory_item_id"
                  :options="drugs"
                  :filterable="false"
                  placeholder="Search for drugs"
                  @search="onDrugSearch"
                  @option:selected="onDrugChange($event, index)"
                  label="trade_name"
                  :loading="isLoading"
                >
                  <template #no-options="{ searching, loading }">
                    <template v-if="searching">No results found for "{{ searching }}"</template>
                    <template v-else-if="loading">Loading results...</template>
                    <template v-else>Type to search for drugs</template>
                  </template>
                  <template #option="option">
                    <div class="select-option">
                      <span>{{ option.trade_name }}</span>
                      <span v-if="option.generic_name"> - ({{ option.generic_name }})</span>
                      <span> - Avl Qty: {{ option.total_quantity }}</span>
                    </div>
                  </template>
                  <template #selected-option="option">
                    <div class="selected-option">
                      {{ option.trade_name }}
                    </div>
                  </template>
                </v-select>
              </div>
            </td>
            <td class="text-center align-middle px-6">
              <input
                type="text"
                v-model="prescription.dose"
                placeholder="e.g 1 tsp, 1 tablet"
                class="w-full border-gray-300 rounded p-1 bg-gray-50"
                required
                @input="resetAvailability(index)"
              />
            </td>
            <td class="text-center align-middle px-4">
              <select
                v-model="prescription.inventory_dosage_frequency_id"
                class="w-full border-gray-300 rounded p-1 bg-gray-50 hover:border-blue-700"
                @change="onDrugChange($event, index); resetAvailability(index)"
                required
              >
                <option v-for="freq in dosageFrequencies" :key="freq.id" :value="freq">
                  {{ freq.name }}
                </option>
              </select>
            </td>
            <td class="text-center align-middle px-6">
              <input
                type="number"
                v-model="prescription.days"
                placeholder="e.g 15"
                class="w-full border-gray-300 rounded p-1 bg-gray-50"
                @input="resetAvailability(index)"
                required
              />
            </td>
            <td class="text-center align-middle mx-2 col-span-3">
              <select
                v-model="prescription.administration_route_id"
                class="w-full border-gray-300 rounded p-1 bg-gray-50"
                required
              >
                <option v-for="route in adminstrationRoutes" :key="route.id" :value="route">
                  {{ route.name }}
                </option>
              </select>
            </td>

            <!-- Dispensing Quantity: manually entered by doctor — no auto-calculation -->
            <td class="text-center align-middle px-2">
              <input
                type="number"
                min="1"
                v-model.number="prescription.quantity"
                placeholder="Enter qty"
                class="w-full border-gray-300 rounded p-1 bg-gray-50"
                @input="resetAvailability(index)"
              />
            </td>

            <td class="text-center align-middle flex justify-stretch">
              <button
                v-if="!prescription.isAvailabilityConfirmed"
                @click="confirmAvailability(index)"
                :disabled="prescription.isConfirmingAvailability"
                class="px-2 py-1 bg-orange-400 text-white rounded hover:bg-orange-500"
              >
                {{ prescription.isConfirmingAvailability ? 'Confirming...' : 'Confirm Availability' }}
              </button>
              <button
                v-else
                @click="addPrescription(index)"
                class="px-2 py-1 bg-custom-yellow text-white rounded hover:bg-custom-blue"
              >
                Add Prescription
              </button>
              <button
                class="text-white font-bold bg-red-500 w-8 h-8 rounded-full flex items-center justify-center ml-2"
                @click.prevent="removeTempPrescription(index)"
              >
                -
              </button>
            </td>
          </tr>
          <!-- Added Prescriptions Table -->
          <tr v-for="(prescription, index) in prescriptionRequests" :key="`added-${index}`" class="mt-3">
            <td class="px-6 py-1 whitespace-nowrap">
              {{ prescription.inventory_item_id?.trade_name || "-" }}
            </td>
            <td class="px-6 py-1 whitespace-nowrap">
              {{ prescription.dose || "-" }}
            </td>
            <td class="px-6 py-1 whitespace-nowrap">
              {{ prescription.inventory_dosage_frequency_id?.name || "-" }}
            </td>
            <td class="px-6 py-1 whitespace-nowrap">
              {{ prescription.days ? `${prescription.days} (days)` : "-" }}
            </td>
            <td class="px-6 py-1 whitespace-nowrap">
              {{ prescription.administration_route_id?.name || "-" }}
            </td>
            <td class="px-6 py-1 whitespace-nowrap">
              {{ prescription.quantity ? `${prescription.quantity} ${prescription.drug_dosage_form || ''}(s)` : "-" }}
            </td>
            <td class="px-6 py-1 whitespace-nowrap">
              <button
                class="text-white font-bold bg-red-500 w-8 h-8 rounded-full flex items-center justify-center"
                @click.prevent="removePrescription(index)"
              >
                -
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import apiClient from "@/services/api";
import vSelect from "vue-select";
import Multiselect from "vue-multiselect";
import "vue-select/dist/vue-select.css";
import "vue-multiselect/dist/vue-multiselect.css";

export default {
  name: "PatientServices.vue",
  components: { vSelect, Multiselect },
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      patientRegForm: { ...this.formData },
      testRequest: {
        labRequestForm: {
          test_type: "",
          priority: "Normal",
          instructions: "",
          quantity: 1,
          bill_category: 2,
          clinical_notes: "",
          unit_price: 0,
        },
        radiologyForm: {
          date: this.getTodayDate(),
          scheduleRequest: "",
          imaging_type: "",
          bodyPartRegion: "",
          priority: "Normal",
          quantity: 1,
          bill_category: 3,
          clinical_notes: "",
          unit_price: 0,
        },
        prescriptionForm: {
          inventory_item_id: null,
          dose: "",
          inventory_dosage_frequency_id: null,
          days: "",
          administration_route_id: null,
          unit_price: 200,
          bill_category: 4,
          quantity: "",
          notes: "",
          drug_dosage_form: "",
          isConfirmingAvailability: false,
          isAvailabilityConfirmed: false,
        },
      },
      labRequests: [],
      radiologyRequests: [],
      prescriptionRequests: [],
      procedureRequests: [],
      tempPrescriptionForms: [],
      labTests: [],
      radiologyTests: [],
      procedures: [],
      drugs: [],
      isLoading: false,
      searchTimeout: null,
      minChars: 3,
      adminstrationRoutes: [],
      dosageFrequencies: [],
    };
  },
  mounted() {
    this.fetchDosageFrequencies();
    this.fetchAdministrationRoutes();
    this.addTempPrescription(); // Initialize with one empty prescription form
  },
  methods: {
    getTodayDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    incrementQty(index) {
      this.procedureRequests[index].quantity += 1;
    },

    decrementQty(index) {
      if (this.procedureRequests[index].quantity > 1) {
        this.procedureRequests[index].quantity -= 1;
      }
    },

    addLabTest() {
      this.labRequests.push({
        test_type: "",
        priority: "Normal",
        instructions: "",
        quantity: 1,
        bill_category: 1,
        clinical_notes: "",
        unit_price: 0,
        referred_out: false,
      });
    },
    removeLabTest(index) {
      this.labRequests.splice(index, 1);
    },
    labChange(event, index) {
      this.labRequests[index].unit_price = this.labRequests[index].test_type?.unit_price;
    },
    addRadiologyTest() {
      this.radiologyRequests.push({
        imaging_type: "",
        priority: "Normal",
        bodyPartRegion: "",
        clinical_notes: "",
        quantity: 1,
        bill_category: 2,
        unit_price: 0,
        referred_out: false,
      });
    },
    removeRadiologyTest(index) {
      this.radiologyRequests.splice(index, 1);
    },
    radiologyChange(event, index) {
      this.radiologyRequests[index].unit_price = this.radiologyRequests[index].imaging_type?.unit_price;
    },
    addTempPrescription() {
      this.tempPrescriptionForms.push({
        inventory_item_id: null,
        dose: "",
        inventory_dosage_frequency_id: null,
        days: "",
        administration_route_id: null,
        unit_price: 200,
        bill_category: 4,
        quantity: "",     // blank — doctor must fill this in explicitly
        notes: "",
        drug_dosage_form: "",
        isConfirmingAvailability: false,
        isAvailabilityConfirmed: false,
      });
    },
    removeTempPrescription(index) {
      this.tempPrescriptionForms.splice(index, 1);
      if (this.tempPrescriptionForms.length === 0) {
        this.addTempPrescription();
      }
    },
    addPrescription(index) {
      const prescription = this.tempPrescriptionForms[index];

      if (prescription.inventory_item_id?.approval_required) {
        this.$toast.error(
          `${prescription.inventory_item_id.trade_name} requires doctor approval. It can only be prescribed from the consultation stage.`
        );
        return;
      }

      if (!prescription.isAvailabilityConfirmed) {
        this.$toast.error("Please confirm drug availability before adding the prescription.");
        return;
      }
      // Validate that quantity was explicitly entered
      if (!prescription.quantity || prescription.quantity <= 0) {
        this.$toast.error("Please enter a dispensing quantity.");
        return;
      }
      if (
        prescription.inventory_item_id &&
        prescription.dose &&
        prescription.inventory_dosage_frequency_id &&
        prescription.days &&
        prescription.administration_route_id
      ) {
        // quantity is already on the form from the input — no override needed
        this.prescriptionRequests.push({ ...prescription });
        this.tempPrescriptionForms.splice(index, 1);
        if (this.tempPrescriptionForms.length === 0) {
          this.addTempPrescription();
        }
      } else {
        this.$toast.error("Please fill all required fields in the prescription form.");
      }
    },
    removePrescription(index) {
      this.prescriptionRequests.splice(index, 1);
    },
    // Procedure Services Methods
    addProcedure() {
      this.procedureRequests.push({
        procedure_type: { ...this.procedureForm?.procedure_type },
        unit_price: this.procedureForm?.unit_price,
        quantity: 1,
        bill_category: 5,
        notes: "",
      });
    },
    removeProcedure(index) {
      this.procedureRequests.splice(index, 1);
    },
    procedureChange(event, index) {
      this.procedureRequests[index].unit_price = this.procedureRequests[index].procedure_type?.unit_price || 0;
    },
    async onProcedureSearch(search) {
      if (search.length < this.minChars) {
        this.procedures = [];
        return;
      }
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.isLoading = true;
      this.searchTimeout = setTimeout(async () => {
        try {
          await this.searchProcedures(search);
        } catch (error) {
          console.error("Procedure search error:", error);
          this.procedures = [];
        } finally {
          this.isLoading = false;
        }
      }, 300);
    },
    async searchProcedures(searchString) {
      try {
        if (searchString.length < 3) {
          return;
        }
        this.isLoading = true;
        const type = "FST-004";
        const payload = { name: searchString, type: type };
        const response = await apiClient.searchConsultationFacilityServices(payload);
        if (response.success) {
          this.procedures = response.data;
        } else {
          this.$toast.error("Unable to search procedures.");
        }
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        this.$toast.error("Unable to search procedures, please check your internet connection.");
      }
    },
    async onSearch(search) {
      if (search.length < this.minChars) {
        this.labTests = [];
        return;
      }
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.isLoading = true;
      this.searchTimeout = setTimeout(async () => {
        try {
          await this.searchService(search);
        } catch (error) {
          console.error("Search error:", error);
          this.labTests = [];
        } finally {
          this.isLoading = false;
        }
      }, 300);
    },
    async searchService(searchString) {
      try {
        if (searchString.length < 3) {
          return;
        }
        this.isLoading = true;
        const type = "FST-002";
        const payload = { name: searchString, type: type };
        const response = await apiClient.searchConsultationFacilityServices(payload);
        if (response.success) {
          this.labTests = response.data;
        } else {
          this.$toast.error("Unable to search diagnosis.");
        }
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        this.$toast.error("Unable to search, please check your internet connection.");
      }
    },
    async onRadiologySearch(search) {
      if (search.length < this.minChars) {
        this.radiologyTests = [];
        return;
      }
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.isLoading = true;
      this.searchTimeout = setTimeout(async () => {
        try {
          await this.searchRadiologyService(search);
        } catch (error) {
          console.error("Search error:", error);
          this.radiologyTests = [];
        } finally {
          this.isLoading = false;
        }
      }, 300);
    },
    async searchRadiologyService(searchString) {
      try {
        if (searchString.length < 3) {
          return;
        }
        this.isLoading = true;
        const type = "FST-003";
        const payload = { name: searchString, type: type };
        const response = await apiClient.searchConsultationFacilityServices(payload);
        if (response.success) {
          this.radiologyTests = response.data;
        } else {
          this.$toast.error("Unable to search radiology tests.");
        }
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        this.$toast.error("Unable to search radiology tests, please check your internet connection.");
      }
    },
    async onDrugSearch(search, loading) {
      if (search.length < this.minChars) {
        this.drugs = [];
        return;
      }
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.isLoading = true;
      loading(true);
      this.searchTimeout = setTimeout(async () => {
        try {
          await this.searchDrug(search);
        } catch (error) {
          console.error("Search error:", error);
          this.drugs = [];
        } finally {
          this.isLoading = false;
          loading(false);
        }
      }, 300);
    },
    async searchDrug(searchString) {
      try {
        if (searchString.length < 3) {
          return;
        }
        this.isLoading = true;
        const payload = { name: searchString };
        const response = await apiClient.searchConsultationInventoryItems(payload);
        this.isLoading = false;
        if (response.success) {
          this.drugs = response.data;
        } else {
          this.$toast.error("Unable to search drugs.");
        }
      } catch (error) {
        this.isLoading = false;
        this.$toast.error("Unable to search drugs, please check your internet connection.");
      }
    },
    async confirmAvailability(index) {
      const prescription = this.tempPrescriptionForms[index];

      // Validate that the doctor has explicitly entered a quantity
      if (!prescription.inventory_item_id || !prescription.quantity || prescription.quantity <= 0) {
        this.$toast.error("Please select a drug and enter a dispensing quantity.");
        return;
      }

      prescription.isConfirmingAvailability = true;
      try {
        const payload = {
          inventory_item_id: prescription.inventory_item_id.id,
          quantity: prescription.quantity,   // uses the manually entered quantity directly
        };
        const response = await apiClient.checkInventoryItemAvailability(payload);
        if (response.success && response.data.available) {
          prescription.isAvailabilityConfirmed = true;
          this.$toast.success("Drug availability confirmed.");
        } else {
          prescription.isAvailabilityConfirmed = false;
          this.$toast.error("Drug is not available in sufficient quantity.");
        }
      } catch (error) {
        prescription.isAvailabilityConfirmed = false;
        this.$toast.error("Failed to confirm availability. Please check your internet connection.");
      } finally {
        prescription.isConfirmingAvailability = false;
      }
    },
    resetAvailability(index) {
      this.tempPrescriptionForms[index].isAvailabilityConfirmed = false;
      this.tempPrescriptionForms[index].isConfirmingAvailability = false;
    },
    onDrugChange(event, index) {
      const drug = event;
      if (drug && drug.total_quantity <= 0) {
        this.$toast.error("Cannot select this item: Out of stock (quantity is 0).");
        this.tempPrescriptionForms[index].inventory_item_id = null;
        return;
      }
      this.tempPrescriptionForms[index].drug_dosage_form = drug?.drug_dosage_form?.name || "";
      this.resetAvailability(index);
    },
    async fetchAdministrationRoutes() {
      try {
        const response = await apiClient.getAdminstrationRoutes();
        if (response.success) {
          this.adminstrationRoutes = response.data;
        } else {
          this.$toast.error("Unable to fetch administration routes.");
        }
      } catch (error) {
        this.$toast.error("Unable to fetch administration routes, please check your internet connection.");
      }
    },
    async fetchDosageFrequencies() {
      try {
        const response = await apiClient.getDosageFrequencies();
        if (response.success) {
          this.dosageFrequencies = response.data;
        } else {
          this.$toast.error("Unable to fetch dosage frequencies.");
        }
      } catch (error) {
        this.$toast.error("Unable to fetch dosage frequencies, please check your internet connection.");
      }
    },
    submitRequests() {
      this.patientRegForm.lab = this.labRequests;
      this.patientRegForm.radiology = this.radiologyRequests;
      this.patientRegForm.prescription = this.prescriptionRequests;
      this.patientRegForm.procedure = this.procedureRequests;
      const requests = {
        lab: this.labRequests,
        radiology: this.radiologyRequests,
        prescription: this.prescriptionRequests,
        procedure: this.procedureRequests,
      };
      this.$emit("update:formData", this.patientRegForm);
      return requests;
    },
  },
};
</script>

<style scoped>
.flowbite-select .vs__dropdown-toggle {
  @apply border-gray-300 rounded-lg shadow-sm focus:border-blue-500 focus:ring-blue-500;
}
.flowbite-select .vs__dropdown-menu {
  @apply border-gray-300 rounded-lg shadow-sm;
}
</style>